import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaImage } from "react-icons/fa";
import { getUserblogs, getblogCategories } from "../../../Services/APIrequests";
import styles from "./home.module.css";
import resource from "../Blogpage/blog.module.css";
import parse from "html-react-parser";
import defaultIMG from "../../../Assets/defaultimg.png";

const BlogImage = ({ src, alt, className }) => {
    const [error, setError] = useState(false);

    if (!src || error) {
        return (
            <div
                className={className}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f1f5f9',
                    fontSize: '40px',
                    color: '#94a3b8'
                }}
            >
                <FaImage />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onError={() => setError(true)}
        />
    );
};

const SampleBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const blogsResponse = await getUserblogs();
                const blogsData = blogsResponse.data.blogs || [];

                // Filter blogs to show only those with `homepage: "1"`
                const homepageBlogs = blogsData.filter(
                    (blog) => blog.homepage === "1"
                );

                setBlogs(blogsData);
                setError(null);
            } catch (err) {
                console.error("Error fetching blogs:", err);
                setError("Failed to load blogs. Please try again later.");
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    // Navigate to blog details
    const handleClick = (blogId) => {
        navigate(`/blog/${blogId}`);
    };

    return (
        <div className={styles.sampleblogs_container}>
            <div className="text-center mb-10">
                <h1 className={styles.sampleblogs_header}>From Our <span style={{ color: 'var(--PrimaryColor)' }}>Blog</span></h1>
                <p className={styles.sampleblogs_subtitle}>Insights, guides, and compliance updates</p>
            </div>

            <div className={styles.home_blog_grid}>
                {loading ? (
                    <p className={resource.loadingText}>Loading blogs...</p>
                ) : error ? (
                    <p className={resource.errorText}>{error}</p>
                ) : blogs.length > 0 ? (
                    blogs.map((blog) => (
                        <div
                            key={blog.blogId}
                            className={styles.home_blog_card}
                            onClick={() => handleClick(blog.blogSlug)}
                            style={{ cursor: "pointer" }}
                        >
                            <BlogImage
                                src={blog.bigImage}
                                alt={blog.title || "Blog Image"}
                                className={styles.home_blog_image}
                            />
                            <div className={styles.home_blog_content}>
                                <span className={styles.home_blog_date}>
                                    {blog.createdAt ? new Date(blog.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : "Jan 28, 2026"}
                                </span>
                                <h3 className={styles.home_blog_title}>
                                    {blog.title}
                                </h3>
                                <div className={styles.home_blog_desc}>
                                    {typeof blog.shortDescription ===
                                        "string" && blog.shortDescription.trim()
                                        ? parse(blog.shortDescription)
                                        : "No description available."}
                                </div>
                                <div style={{ color: "var(--PrimaryColor)" }} className={styles.home_blog_link}>
                                    Read More <FaArrowRightLong size={12} />
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className={resource.noBlogsText}>
                        No blogs available for the homepage.
                    </p>
                )}
            </div>
        </div>
    );
};

export default SampleBlogs;
